<div class="p-2">
  <div #chartContainer id="trend-chart"></div>
</div>